import { useEffect } from "react";
import { options } from "../utils/tmdbToken";
import { useDispatch, useSelector } from "react-redux";
import { addPopular } from "../utils/movieSlice";

const usePopular = () => {
  const nowplaying=useSelector(store=>store.movie.popular)
  const dispatch = useDispatch();
  const fetchToprated = async () => {
    const data = await fetch(
      "https://api.themoviedb.org/3/movie/popular?language=en-US&page=2",
      options
    );
    const json = await data.json();
    dispatch(addPopular(json.results));
  };
  useEffect(() => {
    !nowplaying && fetchToprated();
  }, []);
};
export default usePopular;
